(ns very.re-frame.errors
  (:require
    [re-frame.db :as db]
    [re-frame.interceptor :refer [->interceptor]]
    [oops.core :refer [oset!]]
    )
  )

;; tracking prev db + event in case an error occurs
(def prev-app-db' (atom nil))
(def prev-event' (atom nil))

(defn app-db []
  (deref db/app-db))

(defn prev-app-db []
  (deref prev-app-db'))

(defn prev-event []
  (deref prev-event'))

(defn interceptor
  "Hold onto the previous event and database so that, in the event an error
  occurs, we can have both available for debugging."
  []
  (->interceptor
    :id :error-capture
    :before (fn [ctx]
              (let [evt (get-in ctx [:coeffects :event])
                    db (get-in ctx [:coeffects :db])]
                (reset! prev-event' evt)
                (reset! prev-app-db' db)
                ctx))))

(defn load-db [db-str]
  (reset! db/app-db (cljs.reader/read-string db-str)))

(defn export-db []
  (pr-str (deref db/app-db)))

(oset! js/window "!very.!_debug.!re_frame.!errors.!load_db" load-db)
(oset! js/window "!very.!_debug.!re_frame.!errors.!export_db" export-db)
